<div class="row">
    <div class="col-md-12">
        <h2 style="text-align: center">Diversification clients</h2>
    </div>
</div>
<div class="row" style="min-height: 343.5px">
    <!--current-->
    <div class="col-md-7">
        <div *ngIf="loaded">
            <canvas baseChart
                    [data]="currentChart.data"
                    [labels]="currentChart.labels"
                    [chartType]="currentChart.type"
                    [legend]="currentChart.legend"
                    [options]="options"
                    (chartHover)="chartHovered($event)"
                    (chartClick)="chartClicked($event)"
                    style="display: block; width:100%"></canvas>
        </div>
        <h3 style="text-align: center">Année courante</h3>
    </div>
    <!--previous-->
    <div class="col-md-5">
        <div *ngIf="loaded">
            <canvas baseChart
                    [data]="previousChart.data"
                    [labels]="previousChart.labels"
                    [chartType]="previousChart.type"
                    [legend]="previousChart.legend"
                    [options]="options"
                    (chartHover)="chartHovered($event)"
                    (chartClick)="chartClicked($event)"
                    style="display: block; width:100%"></canvas>
        </div>
        <h3 style="text-align: center">Année précédente</h3>
    </div>
</div>
<div class="row diversification" *ngIf="diversification.others.data && diversification.top.data">
    <div class="col-md-6">
        <h3>Top 15</h3>
        <span class="value big">{{diversification.top.totalPercentS}} %</span>&nbsp;
        <span class="delta big">({{diversification.top.deltaPercentS}} %)</span>
        <br/>
        <span class="value">{{diversification.top.totalS}} €</span>&nbsp;
        <span class="delta">({{diversification.top.deltaS}} €)</span>
    </div>
    <div class="col-md-6">
        <h3>Autres</h3>
        <span class="value big">{{diversification.others.totalPercentS}} %</span>&nbsp;
        <span class="delta big">({{diversification.others.deltaPercentS}} %)</span>
        <br/>
        <span class="value">{{diversification.others.totalS}} €</span>&nbsp;
        <span class="delta">({{diversification.others.deltaS}} €)</span>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <table class="table table-striped table-hover table-top">
            <thead>
            <tr>
                <th style="width: 100%"><h3>Top 15</h3></th>
                <th style="min-width: 80px">Nombre de sessions</th>
                <th style="min-width: 80px">Nombre de stagiaires</th>
                <th style="min-width: 160px">Chiffre d'affaire</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of rawDataTop15">
                <td><a (click)="openInfoModal(data)">{{data.company.name}}</a></td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'sessionCount'" [isAmount]="false">
                        </data-analysis-value>
                    </a>
                </td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'studentCount'" [isAmount]="false">
                        </data-analysis-value>
                    </a>
                </td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'turnover'" [isAmount]="true">
                        </data-analysis-value>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th style="width: 100%"><h3>Autres</h3></th>
                <th style="min-width: 80px">Nombre de sessions</th>
                <th style="min-width: 80px">Nombre de stagiaires</th>
                <th style="min-width: 160px">Chiffre d'affaire</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of rawDataOthers">
                <td><a (click)="openInfoModal(data)">{{data.company.name}}</a></td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'sessionCount'" [isAmount]="false">
                        </data-analysis-value>
                    </a>
                </td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'studentCount'" [isAmount]="false">
                        </data-analysis-value>
                    </a>
                </td>
                <td class="all-height">
                    <a (click)="openInfoModal(data)">
                        <data-analysis-value [data]="data" [property]="'turnover'" [isAmount]="true">
                        </data-analysis-value>
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
<data-analysis-modal #infoModal></data-analysis-modal>


// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/company/company.component.html